
<template>
  <div>

    <v-btn :disabled="!user_allowed" color="error" @click="set_one_comission = true"><v-icon left small>mdi-plus</v-icon> Comissão </v-btn>

    <!-- <v-subheader>Clique para editar</v-subheader> -->
    <v-alert v-if="loading_comissions" type="info" :value="true">
      Carregando...
      <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
    </v-alert>
    <v-data-table v-if="items_c.length" :headers="comp_headers" :items="[...main_data.comissions_attributes, ...items]"
        class="elevation-1" mobile-breakpoint="1">
      <template v-slot:items="props">
        <tr :style="cursor_style" @click="editComission({ com: props.item, idx: props.index })">
          <td class="text-xs-center">{{ props.item.brand_name }}</td>
          <td class="text-xs-center">{{
          is_employee? props.item.product_name : is_product? props.item.employee_name :
          '---' }}</td>
          <td class="text-xs-center">{{ props.item.comission_name }}</td>
          <td class="text-xs-center"> {{
            props.item.comission_type == 'percentage' || props.item.comission_type == 2 ?
              '%' : 'R$'
          }} {{ props.item.comission_floor }}</td>

          <td class="text-xs-center">R$ {{ props.item.profit_floor }}</td>
          <td class="text-xs-center">R$ {{ props.item.profit_step }}</td>
          <td class="text-xs-center">R$ {{ props.item.comission_step }}</td>
        </tr>

      </template>
    </v-data-table>


    <one-comission v-if="set_one_comission" :is_employee="is_employee" :is_product="is_product"
      @close="set_one_comission = false" @new-changed="changeNew" @updated="reloadComissions" @done="setComission"
      :main_data.sync="main_data" :comission.sync="one_comission"></one-comission>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'ListComission',
  components: {
    OneComission: () => import('./OneComission.vue'),
  },
  props: {
    main_data: {
      // employee or product object
      type: Object,
    },
    editing: {
      type: Boolean,
    },
    is_employee: {
      type: Boolean,
      default: true
    },
    is_product: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      key: null,
      items: [],
      loading_comissions: false,
      set_one_comission: false,
      one_comission: {},
      headers: [
        { text: 'Marca', value: 'brand_name' },
        { text: 'Produto', value: 'product_name' },
        { text: 'Modelo', value: 'comission_name' },
        { text: 'Comissão', value: 'comission_floor' },

        { text: 'Lucro inicial', value: 'profit_floor' },
        { text: 'Lucro incremental', value: 'profit_step' },
        { text: 'Comissão incremental', value: 'comission_step' },

      ]
    }
  },
  methods: {
    setComission(e) {
      this.main_data.comissions_attributes.push(e)
      this.set_one_comission = false
      this.one_comission = {}
    },
    editComission({ com, idx }) {
      if (this.editing) {
        if (com.id) {
          Api.Comission.show(com.id).then(r => r.data).then(c => {
            c = c.data ? c.data.attributes : c
            this.one_comission = { ...c }
            this.set_one_comission = true
          })
        } else {
          this.one_comission = { ...com, index: idx }
          this.set_one_comission = true
        }
      }
    },
    reloadComissions() {
      this.set_one_comission = false
      this.one_comission = {}
      this.getComissions()
    },
    getComissions() {
      if (this.main_data.comission_ids.length) {
        this.loading_comissions = true
        let name = this.is_employee ? 'employees' : this.is_product ? 'products' : ''
        Api.Comission.indexByModel({ name, id: this.main_data.id }).then(r => r.data).then(com => {
          com = com.data ? com.data.map(c => c.attributes) : com
          this.items = [...com]
        }).finally(() => {
          this.loading_comissions = false
        })
      }
    },
    setComissions() {
      if (this.main_data.comissions_attributes.length) {
        this.items = [...this.items, ...this.main_data.comissions_attributes]
      }
    },
    changeNew(e) {
      // this.main_data.comissions_attributes[e.idx] = {...e.comission}
      this.items_c
      this.$emit('new-changed', e)
      this.set_one_comission = false
      this.one_comission = {}
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted() {
    if (this.main_data.id) {
      this.getComissions()
    } else {
      this.setComissions()
    }
  },
  computed: {
    items_c() {
      let a = this.items.length ? [...this.items] : []
      return [...a, ...this.main_data.comissions_attributes]
    },
    cursor_style() {
      return this.editing ? 'cursor: pointer' : ''
    },
    comp_headers() {
      if (this.is_employee) {
        return this.headers
      } else if (this.is_product) {
        let arr = [...this.headers]
        arr.splice(1, 1, { text: 'Vendedor', value: 'employee_name' },)
        return arr
      }
    },
    user_allowed() {
      if (this.profile) {
        const { name, translated } = this.profile.included[0].attributes.role.data[0].attributes
        // console.log({name});

        if (name == "Manager" || name.includes("Dir"))
          return true
        else
          return false
      }
    },
    ...mapState({
      profile: state => state.User.oneUser,
    })
  },
  watch: {
    'this.main_data.comissions_attributes'(nv, ov) {
      // this.setComissions()
      if (nv) {
      } else if (nv == false) {
      }
    },
    set_one_comission(nv, ov) {
      if (nv) {

      } else if (nv == false) {
        this.one_comission = {}
      }
    }
  },
}
</script>

<style scoped>

</style>
